export const debtTypes = {
  voucherBook: 'voucherBook',
  reservation: 'reservation',
  topup: 'topup',
}
